var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-select',{attrs:{"disabled":_vm.isDisabled,"select-list":_vm.dropdownList.ProvozovnaId,"value":_vm.ProvozovnaId,"label-key":"PROVOZOVNA_ID"},on:{"update:value":function($event){_vm.ProvozovnaId=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }